import Helper from '@/resources/Helper';
import ModelAccountingData from '@/resources/models/AccountingData';
import ModelStockSyncData from '@/resources/models/StockSyncData';
import ModelStockHistoryData from '@/resources/models/StockHistoryData';
import DBEngine from '@/database/_Base';
import DBStockHistory from '@/database/StockHistory';
import DBJob from '@/database/Job';
import DBCustomer from '@/database/Customer';
import DBCustomerStore from '@/database/CustomerStore';
import DBStock from '@/database/Stock';
import DBStore from '@/database/Store';
import DBInventory from '@/database/Inventory';
import DBAccounting from '@/database/Accounting';

export default {
    data() {
        return {
            formData: {},
            isScrollToError: false
        }
    },
    methods: {
        mixinsJobForm_SetupData(input) {
            this.formData = Object.assign(this.formData, input);
        },
        mixinsJobForm_InitCustomerErrorData() {
            return {
                licensePlate: { blank: false },
                licensePlateProvince: { blank: false },
                carBrand: { blank: false },
                carModel: { blank: false },
                distance: { blank: false },
                picture: { blank: false },
                customerFirstName: { blank: false },
                customerLastName: { blank: false },
                customerTel: { blank: false }
            };
        },
        mixinsJobForm_InitCustomerStoreErrorData() {
            return {
                taxId: { blank: false },
                name: { blank: false },
                contactPerson: { blank: false },
                contactTel: { blank: false },
                address: { blank: false },
                subDistrict: { blank: false },
                district: { blank: false },
                province: { blank: false },
                postCode: { blank: false }
            };
        },
        mixinsJobForm_InitOrderErrorData() {
            return {
                productList: { dot: [], picture: [], price: [] },
                serviceList: { topic: [], price: [] },
                discountList: { remark: [], discount: [] }
            };
        },
        mixinsJobForm_InitTurnPartErrorData() {
            return {
                name: [],
                price: []
            };
        },
        mixinsJobForm_InitBillErrorData() {
            return {
                paymentMethod: { blank: false }
            };
        },
        mixinsJobForm_InitTaxErrorData() {
            return {
                taxName: { blank: false },
                taxId: { blank: false },
                taxAddress: { blank: false }
            };
        },
        mixinsJobForm_ProceedOpenJob() {
            const loader = this.$AppUtility.renderLoadBackdrop();

            this.mixinsJobForm_SaveForm(this.$Constants.JOB_ACTION_STATE_OPEN, this.formType);
            this.mixinsJobForm_ReserveStockData();

            loader.hide();

            this.$router.push('/job/list');
        },
        async mixinsJobForm_ProceedUpdateForm() {
            const loader = this.$AppUtility.renderLoadBackdrop();

            this.mixinsJobForm_SaveForm(this.$Constants.JOB_ACTION_STATE_UPDATE, this.formType);

            // Update Stock
            if (this.loadData.jobType === this.$Constants.JOB_FORM_WALKIN
                || this.loadData.jobType === this.$Constants.JOB_FORM_ONLINE
                || this.loadData.jobType === this.$Constants.JOB_FORM_FLEET
                || this.loadData.jobType === this.$Constants.JOB_FORM_STORE) {
                await this.mixinsJobForm_ReturnStockData(this.loadData.key);
                await this.mixinsJobForm_ReserveStockData();
            }

            loader.hide();

            this.$swal({
                title: 'บันทึกใบงานเรียบร้อยแล้ว',
                icon: 'success'
            });
        },
        async mixinsJobForm_ProceedCloseJob() {
            const loader = this.$AppUtility.renderLoadBackdrop();
            
            await this.mixinsJobForm_SaveForm(this.$Constants.JOB_ACTION_STATE_CLOSE, this.formType);
            
            // Update Stock
            await this.mixinsJobForm_ReturnStockData(this.loadData.key);
            await this.mixinsJobForm_ReserveStockData();

            // Deduct Stock
            await this.mixinsJobForm_DeductStockData();

            // Write Accounting Journal
            await this.mixinsJobForm_WriteSaleAccounting();

            if (this.formData.turnPartList.length > 0) {
                await this.mixinsJobForm_WriteTurnPartAccounting();
            }

            loader.hide();

            this.$swal({
                title: 'ต้องการออกใบเสร็จรับเงิน?',
                text: 'กดปุ่ม PRINT ใบเสร็จรับเงิน',
                icon: 'question',
                showCancelButton: true,
                confirmButtonText: 'PRINT ใบเสร็จ',
                cancelButtonText: 'กลับไปหน้ารายการ'
            }).then((result) => {
                this.jobState = this.$Constants.JOB_STATUS_COMPLETE;
                
                if (result.isConfirmed) {
                    this.mixinsJobForm_PrintForm();
                } else {
                    this.$router.push('/job/list');
                }
            });

            this.jobState = this.$Constants.JOB_STATUS_COMPLETE;

            // Scroll to Panel Operation
            this.$root.$emit('rootSetScrollToBottom');
        },
        async mixinsJobForm_SaveForm(state, type) {
            const currentDate = new Date();

            switch (state) {
                case this.$Constants.JOB_ACTION_STATE_OPEN:
                    this.mixinsJobForm_SetupHeaderFormData(
                        '', // Key
                        this.mixinsJobForm_GenerateNumber(type), // Number
                        this.$Constants.JOB_STATUS_PENDING, // Status
                        currentDate, // Open Date
                        '' // Close Date
                    );
                    break;

                case this.$Constants.JOB_ACTION_STATE_UPDATE:
                    this.mixinsJobForm_SetupHeaderFormData(
                        this.loadData.key, // Key
                        this.loadData.number, // Number
                        this.$Constants.JOB_STATUS_PENDING, // Status
                        this.loadData.openDate, // Open Date
                        '' // Close Date
                    );
                    break;

                case this.$Constants.JOB_ACTION_STATE_CLOSE:
                    this.mixinsJobForm_SetupHeaderFormData(
                        this.loadData.key, // Key
                        this.loadData.number, // Number
                        this.$Constants.JOB_STATUS_COMPLETE, // Status
                        this.loadData.openDate, // Open Date
                        currentDate // Close Date
                    );

                    // Save Close Date
                    this.loadData.closeDate = currentDate;
                    break;
            }
            
            // Save Job
            await DBJob.save(this.formData);

            // Update and Save Customer Data
            // Special Case for Job Store
            // Not Require to Update Customer Data for Job Claim
            if (this.formData.jobType === this.$Constants.JOB_FORM_STORE) {
                await DBCustomerStore.saveCustomerStoreData(
                    this.formData.customerStore.taxId,
                    this.formData.customerStore.name,
                    this.formData.customerStore.contactPerson,
                    this.formData.customerStore.contactTel,
                    this.formData.customerStore.address,
                    this.formData.customerStore.subDistrict,
                    this.formData.customerStore.district,
                    this.formData.customerStore.province,
                    this.formData.customerStore.postCode
                );
            } else if (this.formData.jobType !== this.$Constants.JOB_FORM_CLAIM) {
                await DBCustomer.saveCustomerData(
                    this.formData.customer.licensePlate,
                    this.formData.customer.licensePlateProvince,
                    this.formData.customer.distance,
                    this.formData.customer.carBrand,
                    this.formData.customer.carModel,
                    this.formData.customer.carYearSerie,
                    this.formData.customer.customerFirstName,
                    this.formData.customer.customerLastName,
                    this.formData.customer.customerTel,
                    true
                );
            }
        },
        mixinsJobForm_SetupHeaderFormData(key, number, status, openDate, closeDate) {
            this.formData['key'] = key;
            this.formData['number'] = number;
            this.formData['status'] = status;
            this.formData['openDate'] = openDate;
            this.formData['closeDate'] = closeDate;
            this.formData['jobType'] = this.formType;
        },
        async mixinsJobForm_CancelJob(data) {
            this.$swal({
                title: 'ยกเลิกรายการ?',
                text: 'โปรดยืนยันว่าต้องการยกเลิกรายการทั้งหมด',
                icon: 'question',
                showCancelButton: true
            }).then(async (result) => {
                if (result.isConfirmed) {
                    const loader = this.$AppUtility.renderLoadBackdrop();

                    if (data.jobType === this.$Constants.JOB_FORM_WALKIN
                        || data.jobType === this.$Constants.JOB_FORM_ONLINE
                        || data.jobType === this.$Constants.JOB_FORM_FLEET
                        || data.jobType === this.$Constants.JOB_FORM_STORE) {
                        await this.mixinsJobForm_ReturnStockData(data.key);
                    }
                    
                    await DBJob.delete(data);

                    this.$router.push('/job/list');
                    loader.hide();
                }
            });
        },
        async mixinsJobForm_PrintForm() {
            const loader = this.$AppUtility.renderLoadBackdrop();
            const jobData = await DBJob.getDetailByNumber(this.loadData.number, this.loadData.jobType);
            const storeData = await DBStore.get();
            const content = {
                data: jobData,
                store: storeData.content
            };

            loader.hide();

            this.$refs.refPrintDocument.printForm(content);
        },
        mixinsJobForm_SetupSyncQuantity(productList) {
            const syncDataList = [];

            for (const item of productList) {
                const syncIndex = syncDataList.findIndex(x => x.inventoryKey === item.inventoryKey && x.dot === item.input.dot);

                if (syncIndex > -1) {
                    syncDataList[syncIndex].quantity += item.input.quantity;
                } else {
                    syncDataList.push({
                        inventoryKey: item.inventoryKey,
                        dot: item.input.dot,
                        quantity: item.input.quantity
                    });
                }
            }

            return syncDataList;
        },
        async mixinsJobForm_ReserveStockData() {
            const syncDataList = this.mixinsJobForm_SetupSyncQuantity(this.formData.order.productList);

            for (const item of syncDataList) {
                if (item.inventoryKey !== '-') {
                    const syncData = ModelStockSyncData.data();
                    syncData.key = item.inventoryKey;
                    syncData.operand = DBStock.operandAction().reserve;
                    syncData.amount = item.quantity;
    
                    await DBStock.reserveStockData(syncData);
                }
            }
        },
        async mixinsJobForm_ReturnStockData(jobKey) {
            const loadData = await DBJob.getDetail(jobKey);
            const syncDataList = this.mixinsJobForm_SetupSyncQuantity(loadData.order.productList);

            for (const item of syncDataList) {
                if (item.inventoryKey !== '-') {
                    const syncData = ModelStockSyncData.data();
                    syncData.key = item.inventoryKey;
                    syncData.operand = DBStock.operandAction().return;
                    syncData.amount = item.quantity;
    
                    await DBStock.returnReserveData(syncData);
                }
            }
        },
        async mixinsJobForm_DeductStockData() {
            const syncDataList = this.mixinsJobForm_SetupSyncQuantity(this.formData.order.productList);

            for (const item of syncDataList) {
                if (item.inventoryKey !== '-') {
                    let stockData = await DBStock.getDetail(item.inventoryKey);
                    const isConsignment = stockData.dots.filter(x => x.amountConsign > 0).length > 0 ? true : false;
    
                    stockData = await this.mixinsJobForm_ProcessDeductStock(stockData, item, isConsignment);

                    if (!this.$AppUtility.isAnyStockAvailable(stockData)) {
                        await this.mixinsJobForm_ClearCostCounterHistory(item.inventoryKey);
                    }
                }
            }
        },
        async mixinsJobForm_ClearCostCounterHistory(inventoryKey) {
            // Get History
            const history = await DBStockHistory.getHistoryByInventory(inventoryKey);

            if (history) {
                await this.$AppUtility.clearCostCounterHistory(inventoryKey, history);

                // Calculate Average Cost
                const costAverage = await this.$AppUtility.calculateAverageCost(history);
    
                // Save Inventory Data
                const inventory = await DBInventory.getDetail(inventoryKey);
                inventory.inventoryData.cost = costAverage;
    
                await DBInventory.save(inventory);
            }
        },
        async mixinsJobForm_ProcessDeductStock(stockData, itemData, isConsignment) {
            // Submit return reserve stock
            // If consignment, proceed deduct only consign stock
            // Deduct at current dot, then deduct at blank
            // If Normal, proceed deduct sublet first
            // Deduct at current dot, then deduct at blank
            // If sublet not enough, proceed deduct normal
            // Deduct at current dot, then deduct at blank
    
            // Submit return reserve stock
            const syncReturnReserveData = ModelStockSyncData.data();

            syncReturnReserveData.key = itemData.inventoryKey;
            syncReturnReserveData.operand = DBStock.operandAction().purchase;
            syncReturnReserveData.amount = itemData.quantity;

            stockData = await DBStock.returnReserveData(syncReturnReserveData);
    
            // Remaining Process
            if (isConsignment) {
                await this.mixinsJobForm_SaveDeductStock(itemData.inventoryKey, stockData, itemData.dot, DBStock.stockType().consign, 'amountConsign', itemData.quantity);
            } else {
                await this.mixinsJobForm_SaveDeductStock(itemData.inventoryKey, stockData, itemData.dot, DBStock.stockType().sublet, 'amountSublet', itemData.quantity);
            }

            return stockData;
        },
        async mixinsJobForm_SaveDeductStock(inventoryKey, stockData, dotName, stockType, property, amount) {
            let dotIndex = stockData.dots.findIndex(x => x.name === dotName || (!x.name && dotName === '-'));
    
            if (dotIndex === -1) {
                dotIndex = stockData.dots.findIndex(x => !x.name);
            }
    
            // Setup sync data
            const syncDeductData = ModelStockSyncData.data();
            syncDeductData.key = inventoryKey;
            syncDeductData.type = stockType;
            syncDeductData.dot = dotName;
            syncDeductData.operand = DBStock.operandAction().deduct;
            syncDeductData.amount = amount;
    
            // Setup over amount
            const currentAmount = stockData.dots[dotIndex][property];
            let adjustAmount = parseInt(amount);
            let overAmount = 0;
    
            if (currentAmount < adjustAmount) {
                overAmount = adjustAmount - currentAmount;
                adjustAmount = currentAmount;
            }
    
            if (adjustAmount > 0) {
                // Deduct Dot Amount
                stockData.dots[dotIndex][property] -= adjustAmount;

                await DBStock.save(stockData, syncDeductData, DBEngine.syncAction().deductStock);
                await this.mixinsJobForm_SubmitStockHistory(inventoryKey, stockType, dotName, DBStock.operandAction().decrease, adjustAmount);
            }
    
            // In Case, Dot Amount is Not Enough
            if (overAmount > 0 && stockType === DBStock.stockType().consign && dotName !== '-') {
                await this.mixinsJobForm_SaveDeductStock(inventoryKey, stockData, '-', DBStock.stockType().consign, 'amountConsign', overAmount);
            } else if (overAmount > 0 && stockType === DBStock.stockType().sublet && dotName !== '-') {
                await this.mixinsJobForm_SaveDeductStock(inventoryKey, stockData, dotName, DBStock.stockType().normal, 'amountNormal', overAmount);
            } else if (overAmount > 0 && stockType === DBStock.stockType().normal && dotName !== '-') {
                await this.mixinsJobForm_SaveDeductStock(inventoryKey, stockData, '-', DBStock.stockType().sublet, 'amountSublet', overAmount);
            } else if (overAmount > 0 && stockType === DBStock.stockType().sublet && dotName === '-') {
                await this.mixinsJobForm_SaveDeductStock(inventoryKey, stockData, dotName, DBStock.stockType().normal, 'amountNormal', overAmount);
            }
        },
        async mixinsJobForm_SubmitStockHistory(key, type, dot, operand, amount) {
            const history = ModelStockHistoryData.data();
    
            history.inventoryKey = key;
            history.type = type;
            history.dot = dot;
            history.operand = operand;
            history.adjustAmount = amount;
            history.averageCost = 0;
            history.isCountAverage = false;
            history.updateAt = Helper.getClientTime();
    
            await DBStockHistory.save(history);
        },
        async mixinsJobForm_WriteSaleAccounting() {
            const title = 'ขายสินค้าและบริการหมายเลขใบงาน #' + this.formData.number;
            const orderPrice = this.$AppUtility.calculateOrderTotalPrice(this.formData.order);
            const isClonable = this.mixinsJobForm_CheckClonableAccounting();
            const tax = orderPrice * 0.07;

            // Book Number 1
            const bookData1 = this.mixinsJobForm_SetupAccountingData(
                title,
                orderPrice,
                '',
                this.formData.bill.includeTax ? tax : '',
                1,
                '',
                isClonable
            );

            const originalKey = await DBAccounting.save(bookData1);

            // Book Number 2
            if (!isClonable) {
                const bookData2 = this.mixinsJobForm_SetupAccountingData(
                    title,
                    orderPrice,
                    '',
                    tax,
                    2,
                    originalKey.key,
                    false
                );

                await DBAccounting.save(bookData2);
            }
        },
        async mixinsJobForm_WriteTurnPartAccounting() {
            let turnPartPrice = 0;

            // Calculate Total Price
            this.formData.turnPartList.forEach((item) => {
                if (item.price) {
                    turnPartPrice += parseFloat(item.price);
                }
            });
            
            const syncData = this.mixinsJobForm_SetupAccountingData(
                'รับเทิร์นสินค้าหมายเลขใบงาน #' + this.formData.number,
                '',
                turnPartPrice,
                1,
                '',
                true
            );

            await DBAccounting.save(syncData);
        },
        mixinsJobForm_SetupAccountingData(title, revenue, expense, tax, bookNumber, originalBook, isClonable) {
            const accountingModel = ModelAccountingData.data();

            accountingModel.key = '';
            accountingModel.date = new Date();
            accountingModel.title = title;
            accountingModel.revenue = revenue;
            accountingModel.expense = expense;
            accountingModel.tax = tax;
            accountingModel.reference = '/job/walkin?o=' + this.formData.number;
            accountingModel.bookNumber = bookNumber;
            accountingModel.originalBook = originalBook;
            accountingModel.isClonable = isClonable;

            return accountingModel;
        },
        mixinsJobForm_CheckClonableAccounting() {
            let isClonable = true;

            // Payment Method is Credit Card
            if (this.formData.bill.paymentMethod === this.$Constants.PAYMENT_METHOD_CASH) {
                isClonable = false;
            }

            // Include Tax
            if (this.formData.bill.includeTax) {
                isClonable = false;
            }

            return isClonable;
        },
        mixinsJobForm_GenerateNumber(type) {
            let number = '';

            // Start Letter
            let startLetter = '';

            switch (type) {
                case this.$Constants.JOB_FORM_WALKIN:
                    startLetter = 'W';
                    break;
                
                case this.$Constants.JOB_FORM_ONLINE:
                    startLetter = 'B';
                    break;

                case this.$Constants.JOB_FORM_FLEET:
                    startLetter = 'F';
                    break;

                case this.$Constants.JOB_FORM_STORE:
                    startLetter = 'T';
                    break;

                case this.$Constants.JOB_FORM_SERVICE:
                    startLetter = 'S';
                    break;

                case this.$Constants.JOB_FORM_CLAIM:
                    startLetter = 'C';
                    break;
            }

            // Date Number
            const today = new Date();

            let orderDayNumber = [ today.getFullYear().toString().substring(2), 
                                    Helper.getLeadingZero((today.getMonth() + 1), 2),
                                    Helper.getLeadingZero((today.getDate()), 2),
                                    Helper.getLeadingZero((today.getHours()), 2),
                                    Helper.getLeadingZero((today.getMinutes()), 2),
                                    Helper.getLeadingZero((today.getSeconds()), 2)
                                ].join('');

            // Random Number
            const randomNumber = Math.floor(Math.random() * 90000) + 10000;

            // Combine
            number = [ startLetter, orderDayNumber, randomNumber ].join('-');

            return number;
        },
        mixins_ResetScrollToError() {
            this.isScrollToError = false;
        },
        mixins_ScrollToError(panel) {
            setTimeout(() => {
                if (!this.isScrollToError) {
                    const element = document.getElementById(panel);
                    element.scrollIntoView();
                }
    
                this.isScrollToError = true;
            }, 100);
        },
        mixins_ValidateCustomer() {
            let valid = true;

            for (const property in this.errorData.customer) {
                if (typeof this.formData.customer[property] === 'string' || this.formData.customer[property] instanceof String) {
                    if (!this.formData.customer[property].trim()) {
                        this.errorData.customer[property].blank = true;
                        valid = false;
                    }
                }

                if (this.formData.customer[property].constructor === Array) {
                    let hasValue = false;

                    this.formData.customer[property].forEach((item) => {
                        if (item) {
                            hasValue = true;
                        }
                    });

                    if (!hasValue) {
                        this.errorData.customer[property].blank = true;
                        valid = false;
                    }
                }
            }

            return valid;
        },
        mixins_ValidateCustomerStore() {
            let valid = true;

            for (const property in this.errorData.customerStore) {
                if (!this.formData.customerStore[property].trim()) {
                    this.errorData.customerStore[property].blank = true;
                    valid = false;
                }
            }

            return valid;
        },
        mixins_ValidateProduct(state) {
            let valid = true;

            if (state !== this.$Constants.JOB_ACTION_STATE_OPEN) {
                this.formData.order.productList.forEach((item, index) => {
                    if (!item.input.dot && item.productData.productCategory === this.$Constants.CATEGORY_TIRE) {
                        this.errorData.order.productList.dot.push({ blankIndex: index });
                        valid = false;
                    }

                    if (!item.input.picture && item.productData.productCategory === this.$Constants.CATEGORY_TIRE) {
                        this.errorData.order.productList.picture.push({ blankIndex: index });
                        valid = false;
                    }

                    if (!item.input.price) {
                        this.errorData.order.productList.price.push({ blankIndex: index });
                        valid = false;
                    }
                });
            }

            if (this.formData.order.serviceList.length > 0) {
                this.formData.order.serviceList.forEach((item, index) => {
                    if (!item.topic) {
                        this.errorData.order.serviceList.topic.push({ blankIndex: index });
                        valid = false;
                    }

                    if (!item.price) {
                        this.errorData.order.serviceList.price.push({ blankIndex: index });
                        valid = false;
                    }
                });
            }

            if (this.formData.order.discountList.length > 0) {
                this.formData.order.discountList.forEach((item, index) => {
                    if (!item.remark) {
                        this.errorData.order.discountList.remark.push({ blankIndex: index });
                        valid = false;
                    }

                    if (!item.discount) {
                        this.errorData.order.discountList.discount.push({ blankIndex: index });
                        valid = false;
                    }
                });
            }

            return valid;
        },
        mixins_ValidateTurnPart() {
            let valid = true;

            if (this.formData.turnPartList.length > 0) {
                this.formData.turnPartList.forEach((item, index) => {
                    if (!item.name) {
                        this.errorData.turnPartList.name.push({ blankIndex: index });
                        valid = false;
                    }

                    if (!item.price) {
                        this.errorData.turnPartList.price.push({ blankIndex: index });
                        valid = false;
                    }
                });
            }

            return valid;
        },
        mixins_ValidateBill() {
            let valid = true;

            for (const property in this.errorData.bill) {
                if (!this.formData.bill[property].trim()) {
                    this.errorData.bill[property].blank = true;
                    valid = false;
                }
            }

            if (this.formData.tax.requireTax) {
                for (const property in this.errorData.tax) {
                    if (!this.formData.tax[property].trim()) {
                        this.errorData.tax[property].blank = true;
                        valid = false;
                    }
                }
            }
            
            return valid;
        },
        mixins_ValidateService() {
            let valid = true;

            if (this.formData.service.checkProblem) {
                if (!this.formData.service.problemDetail.trim()) {
                    this.errorData.service.problemDetail.blank = true;
                    valid = false;
                }
            }
            
            return valid;
        },
        mixins_ValidateCustomerClaim() {
            let valid = true;

            for (const property in this.errorData.customer) {
                if (!this.formData.customer[property].trim()) {
                    this.errorData.customer[property].blank = true;
                    valid = false;
                }
            }

            return valid;
        },
        mixins_ValidateProductClaim() {
            let valid = true;

            for (const property in this.errorData.product) {
                if (!this.formData.product.replace[property].trim()) {
                    this.errorData.product[property].blank = true;
                    valid = false;
                }
            }

            if (!this.formData.product.cause.trim()) {
                this.errorData.cause.blank = true;
                valid = false;
            }

            return valid;
        },
        mixins_ValidatePictureClaim() {
            let valid = true;
            let hasValue = false;

            this.formData.picture.forEach((item) => {
                if (item) {
                    hasValue = true;
                }
            });

            if (!hasValue) {
                this.errorData.picture.blank = true;
                valid = false;
            }

            return valid;
        },
        mixins_ValidateClaimResult() {
            let valid = true;

            if (this.formData.claim.result === '') {
                this.errorData.claim.result.blank = true;
                valid = false;
            }

            return valid;
        }
    }
}